import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getUserSession } from "../component/userInfo";

const UserRegForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("user"); // Default role
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !password) {
      alert("이름, 이메일, 비밀번호를 모두 입력해주세요.");
      return;
    }

    const userSession = getUserSession();
    const apiUrl = "/json/users.php";

    try {
      const formData = new FormData();
      formData.append("action", "register"); // Assuming 'register' is the action for creating a user
      formData.append("name", name);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("role", role);
      formData.append("creator_uid", userSession.uid); // Pass creator's uid

      const res = await fetch(apiUrl, { method: "POST", body: formData });
      const result = await res.json();

      if (result.success) {
        alert("사용자가 성공적으로 등록되었습니다.");
        navigate("/UserList"); // Navigate to user list
      } else {
        alert("사용자 등록에 실패했습니다: " + result.message);
      }
    } catch (error) {
      console.error("Failed to register user:", error);
      alert("사용자 등록 중 오류가 발생했습니다.");
    }
  };

  return (
    <div id="content">
        <div className="container-fluid">
            <h1 className="h3 mb-2 text-gray-800">신규 사용자 등록</h1>
            <div className="card shadow mb-4">
                <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formUserName">
                        <Form.Label>이름</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="이름을 입력하세요"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formUserEmail">
                        <Form.Label>이메일</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="이메일을 입력하세요"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formUserPassword">
                        <Form.Label>비밀번호</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="비밀번호를 입력하세요"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formUserRole">
                        <Form.Label>권한</Form.Label>
                        <Form.Select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="user">user</option>
                            <option value="editor">editor</option>
                            <option value="admin">admin</option>
                        </Form.Select>
                        </Form.Group>

                        <Button variant="primary" type="submit">
                        등록
                        </Button>
                        <Button
                        variant="secondary"
                        className="ms-2"
                        onClick={() => navigate(-1)}
                        >
                        취소
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    </div>
  );
};

export default UserRegForm;
